var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432 -375)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(432 375)",
    fill: "none",
    stroke: "#74b1ee",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    y2: 10,
    transform: "translate(440.5 378.5)",
    fill: "none",
    stroke: "#74b1ee",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    transform: "translate(435.5 383.5)",
    fill: "none",
    stroke: "#74b1ee",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.db3dc751fc4e1cf1e3c4b04e0567277e.svg";
export { ForwardRef as ReactComponent };